import {
  ApiResponse,
  QuestionnaireRequest,
  QuestionnaireResponse,
} from '../types/api';
import { lifeApi } from './base';

const getQuestionnaire = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuestionnaire: builder.query<
      ApiResponse<QuestionnaireResponse>,
      QuestionnaireRequest
    >({
      query: (params) => ({
        url: '/questions',
        params,
      }),
    }),
  }),
});

export const { useGetQuestionnaireQuery } = getQuestionnaire;
